<template>
  <d-navbar-nav class="flex-row">
    <li class="nav-item border-left border-right lang-switcher">
      <language-switcher />
    </li>

    <!--
    <li class="nav-item border-left border-right dropdown notifications">
      <a class="nav-link nav-link-icon text-center" v-d-toggle.notifications>
        <div class="nav-link-icon__wrapper">
          <i class="material-icons">&#xE7F4;</i>
          <d-badge pill theme="danger">2</d-badge>
        </div>
      </a>

      <d-collapse id="notifications" class="dropdown-menu dropdown-menu-large">
        <d-dropdown-item>
          <div class="notification__icon-wrapper">
            <div class="notification__icon">
              <i class="material-icons">&#xE6E1;</i>
            </div>
          </div>
          <div class="notification__content">
            <span class="notification__category">Analytics</span>
            <p>
              Your website’s active users count increased by
              <span
                class="text-success text-semibold"
              >28%</span> in the last week. Great job!
            </p>
          </div>
        </d-dropdown-item>
        <d-dropdown-item href="#">
          <div class="notification__icon-wrapper">
            <div class="notification__icon">
              <i class="material-icons">&#xE8D1;</i>
            </div>
          </div>
          <div class="notification__content">
            <span class="notification__category">Sales</span>
            <p>
              Last week your store’s sales count decreased by
              <span
                class="text-danger text-semibold"
              >5.52%</span>. It could have been worse!
            </p>
          </div>
        </d-dropdown-item>
        <d-dropdown-item class="notification__all text-center">View all Notifications</d-dropdown-item>
      </d-collapse>
      
    </li>
    -->
    <li class="nav-item dropdown">
      <a class="nav-link dropdown-toggle text-nowrap px-3" @click="toggleMenu()" ref="menuToggle">
        <img
          class="user-avatar rounded-circle mr-2"
          src="@/assets/images/avatars/avatar.svg"
          alt="User Avatar"
        />
        <span class="d-none d-md-inline-block align-account">
          {{
          getUsername
          }}
        </span>
      </a>

      <d-collapse
        id="user-actions"
        class="dropdown-menu dropdown-menu-large"
        v-if="toggled"
        style="display:block"
      >
        <d-dropdown-item>
          <div @click="navigateTo('edit-user-profile')">
            <i class="material-icons">&#xE7FD;</i>
            {{ $t("dropdown.account") }}
          </div>
        </d-dropdown-item>
        <d-dropdown-item v-if="getCurrentUser.premium">
          <div @click="navigateTo('invoices')">
            <i class="material-icons">&#xE896;</i>
            {{ $t("dropdown.invoices") }}
          </div>
        </d-dropdown-item>
        <!-- <d-dropdown-item href="/login">
          <i class="material-icons">&#xE7FE;</i> Add Account
        </d-dropdown-item>-->
        <d-dropdown-divider />
        <d-dropdown-item class="text-danger">
          <div @click="logout()">
            <i class="material-icons text-danger">&#xE879;</i>
            {{ $t("dropdown.logout") }}
          </div>
        </d-dropdown-item>
      </d-collapse>
    </li>
  </d-navbar-nav>
</template>

<script>
import { AUTH_LOGOUT } from "@/store/types";
import { mapGetters } from "vuex";
import LanguageSwitcher from "@/components/common/LanguageSwitcher";

export default {
  components: {
    LanguageSwitcher
  },
  computed: {
    ...mapGetters(["getCurrentUser"]),
    getUsername() {
      if (!this.getCurrentUser) return "";

      return this.getCurrentUser.first_name && this.getCurrentUser.last_name
        ? `${this.getCurrentUser.first_name} ${this.getCurrentUser.last_name}`
        : this.getCurrentUser.email;
    }
  },
  data() {
    return {
      toggled: false
    };
  },
  mounted() {
    document.body.addEventListener("click", this.handleOutsideClick);
  },
  destroyed() {
    document.body.removeEventListener("click", this.handleOutsideClick);
  },
  methods: {
    handleOutsideClick(event) {
      if (
        event.target === this.$refs["menuToggle"] ||
        event.target.parentElement === this.$refs["menuToggle"]
      )
        return;

      if (this.toggled) {
        event.stopPropagation();
        this.toggleMenu();
      }
    },
    navigateTo(name) {
      this.$router.push({ name });
      this.toggleMenu();
    },
    toggleMenu() {
      this.toggled = !this.toggled;
    },
    async logout() {
      await this.$store.dispatch(AUTH_LOGOUT);
      this.$router.push({ name: "login" });
    }
  }
};
</script>

<style lang="scss" scoped>
.nav-link:hover {
  cursor: pointer;
}

.lang-switcher {
  margin-top: -8px;
  margin-right: 0px !important;
  padding: 0 9px 0 2px;
  ul {
    top: 5px !important;
    right: 6px !important;
  }
}

.align-account {
  padding-top: 9px;
}

/* IE11 Navbar flex fix. */
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .navbar-nav {
    align-items: stretch !important;
    flex: 1 1 100%;
    flex-flow: row wrap;
  }

  .nav-item.notifications {
    margin-left: auto !important;
  }
}
</style>

<style lang="scss">
// Unscoped styles to leak into LanguageSwitcher component in dashboard (NavbarNav)
.langPosition {
  margin-right: 0px !important;
}
.lang-switcher {
  margin-right: 0px !important;
  ul {
    top: 65px !important;
    right: 150px !important;
  }
}

@media (max-width: 768px) {
  .dropdown-toggle {
    padding-top: 13px !important;
  }
  .lang-switcher {
    padding: 0 4px 0 4px;
    ul {
      top: 55px !important;
      right: initial !important;
      left: 0px !important;
    }
  }
}
</style>
